module.exports = __webpack_public_path__ + "media/images/front/icon_tag-fed4cb207afca08582f8a7667b65a90f.png";